import { render, staticRenderFns } from "./Nro_Entrega_Bolsa.vue?vue&type=template&id=3afebc1e"
import script from "./Nro_Entrega_Bolsa.vue?vue&type=script&lang=js"
export * from "./Nro_Entrega_Bolsa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports